// CornerButton.jsx
// Small corner-cycling icon button used to select a corner (cycles clockwise on click).
//
// Copyright Viktor Eberhardt, 2025
// Author: Viktor Eberhardt

// Framework imports
import React from "react";
import PropTypes from "prop-types";

// MUI imports (single-line)
import IconButton from "@mui/material/IconButton";

// HSA imports

const CornerButton = ({ value, onChange, disabled, title }) => {
  const order = ["top-left", "top-right", "bottom-right", "bottom-left"];
  const next = (e) => {
    // prevent the parent FormControlLabel from toggling the checkbox
    e?.stopPropagation?.();
    e?.preventDefault?.();
    const i = order.indexOf(value);
    const n = order[(i + 1) % order.length];
    onChange?.(n);
  };
  // Indicator square size and padding inside the frame
  const IND_SIZE = 6; // a little bigger than previous 5px diameter dot
  const PADDING = 4; // distance from frame edge to indicator
  const pos = (corner) => {
    switch (corner) {
      case "top-left":
        return { x: PADDING, y: PADDING };
      case "top-right":
        return { x: 24 - PADDING - IND_SIZE, y: PADDING };
      case "bottom-right":
        return { x: 24 - PADDING - IND_SIZE, y: 24 - PADDING - IND_SIZE };
      case "bottom-left":
        return { x: PADDING, y: 24 - PADDING - IND_SIZE };
      default:
        return { x: PADDING, y: PADDING };
    }
  };
  const { x, y } = pos(value || "top-left");
  return (
    <IconButton
      size="small"
      onClick={next}
      disabled={disabled}
      title={title}
      aria-label="change corner"
    >
      <svg width="24" height="24" viewBox="0 0 24 24">
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="3"
          ry="3"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <rect
          x={x}
          y={y}
          width={IND_SIZE}
          height={IND_SIZE}
          fill="currentColor"
        />
      </svg>
    </IconButton>
  );
};

CornerButton.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

export default CornerButton;
